import React, { Component } from 'react';
import ProjectWiseEquipmentDt from '../../components/ProjectWiseEquipmentDt';

class ProjectWiseEquipmentReport extends Component {
    state = {}
    render() {
        return (
            <div className="card card-custom">

                <div className="card-header">
                    <h3 className="card-title"><p className="text-primary">Project Wise Equipment List</p></h3>
                </div>

                <div className="card-body">
                    <ProjectWiseEquipmentDt />
                </div>
            </div>

        );
    }
}

export default ProjectWiseEquipmentReport;